module.exports = __webpack_public_path__ + "static/par-monument.716e6c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/par-monument.png
// module id = 380
// module chunks = 35783957827783 114276838955818